
import { Vue, Component, Prop } from "vue-property-decorator";
import { queries } from "@/apollo";
import * as legacyApollo from "@/apollo/legacySmartQuery";
import { customMoment } from "@/main";
import { User, TtPage } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { formatCount } from "@/helpers/formatCount";
import { startCase, sortBy, groupBy } from "lodash";
import TTPageDetailsModal from "../bet-details/TTPageDetailsModal.vue";
import { useTranslation } from "@/store/translation";

@Component({
  mixins: [legacyApollo.legacySmartQueries({
    user: {
      query: queries.userTtPages,
      fetchPolicy: "cache-and-network",
      skip() {
        return !this.userId || !this.value;
      },
      variables() {
        return {
          releaseDateStart: this.releaseDateStart,
          releaseDateEnd: this.releaseDateEnd,
          behalfOf: this.userId
        };
      }
    }
  })],
  components: {
    TTPageDetailsModal,
  }
})
export default class TTCopyBetModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ required: true }) userId!: boolean;
  user = null as null | User;

  selectedPage = null as null | TtPage
  showPageDetailModal = false;

  t = (text: string) => useTranslation().$t(text);

  releaseDateStart = customMoment()
    .add(-3, "weeks")
    .startOf("day")
    .toDate();

  releaseDateEnd = customMoment()
    .startOf("day")
    .toDate();

  startCase = startCase;
  formatCount = formatCount;
  formatDollar = formatDollar;

  get processedPages() {
    return sortBy(this.user?.ttPages, p => -customMoment(p.createdAt).unix());
  }

  get processedPagesByReleaseDate() {
    return Object.entries(groupBy(this.processedPages, p => p.releaseDate)).sort(([releaseDateA], releaseDateB) => {
      return customMoment(releaseDateB[0]).unix() - customMoment(releaseDateA[0]).unix();
    }).map(([releaseDate, pages]) => {
      // aggregate
      const unitCount = pages.reduce((acc, page) => acc + page.calculation.unit, 0);
      return {
        releaseDate,
        pages,
        agg: {
          unitCount
        }
      }
    }).sort((a, b) => {
      return customMoment(b.releaseDate).unix() - customMoment(a.releaseDate).unix();
    });
  }


  openPage(page: TtPage) {
    this.selectedPage = page;
    this.showPageDetailModal = true;
  }


  toggleModal(val: boolean) {
    this.$emit("input", val);
  }

  handleSubmit() {
    this.toggleModal(!this.value);
  }

  formatDatetime(dateStr: string | Date) {
    return customMoment(dateStr).fromNow()
  }
  formatDate(dateStr: string | Date) {
    return customMoment(dateStr).format("DD/MM/YYYY");
  }
  formatReleaseDate(dateStr: string | Date) {
    return customMoment(dateStr).format("ddd, DD/MM/YYYY");
  }

  reloadAll() {
    legacyApollo.refetchLegacySmartQueries(this);
  }


  handleCopy(id: TtPage["id"]) {
    const page = this.user?.ttPages.find(p => p.id === id);
    if (!page) {
      return;
    }
    this.$emit("copy", page);
    this.toggleModal(false);
    // this.selectedPage = page;
    // this.showPageDetailModal = true;
  }
}
